import classnames from 'classnames/bind';
import React from 'react';

import { IconQuestion } from 'reactApp/components/icons/question';
import { Tooltip } from 'reactApp/components/Tooltip/Tooltip';

import styles from './QuestionTooltip.css';

const css = classnames.bind(styles);

export const QuestionTooltip = ({
    children = '',
    text = children,
    ...props
}) => (
    <Tooltip
        trigger={<IconQuestion className={css('icon')} />}
        content={children || text}
        position="bottom center"
        hoverable
        {...props}
    />
);
